<template>
  <li class="main-menu-item" :class="{
    open: open() == index,
    'is-open': showMegamenu,
  }" @mouseenter="handleMouseEvent(false)" @mouseleave="handleMouseEvent(true)">
    <span class="main-menu-item-wrapper" ref="link" :class="{ 'is-active': isActive }">
      <slot></slot>
      <button aria-lable="Toggle Megamenu" class="dropdown-icon" ref="icon" v-icon:chevron-down @click="onToggle"></button>
    </span>
    <Transition name="fade">
      <div class="main-menu-dropdown-megamenu" v-show="showMegamenu">
        <div class="overlay"></div>
        <div class="main-menu-dropdown-megamenu-container custom-scrollbar">
          <div class="container">
            <div class="main-menu-dropdown-megamenu-wrapper">
              <slot name="megamenu"></slot>
            </div>
          </div>
        </div>
        <button type="button" class="main-menu-dropdown-megamenu-button" @click="handleClose">
          <i class="icon" v-icon:xmark></i>
        </button>
      </div>
    </Transition>
  </li>
</template>

<script>
import { EventBus } from "../../EventBus";

export default {
  name: "VMegamenu",
  props: {
    index: {
      type: Number,
      require: true,
    },
  },
  inject: ["onOpen", "open"],
  data() {
    return {
      mouseOut: true,
      menuItem: null,
      isActive: false,
      showMegamenu: false,
    };
  },
  mounted() {
    EventBus.$on("closeMegamenu", this.handleClose);
    // EventBus.$on("focus-outside", this.handleFocusOutside);

    this.menuItem = this.$refs["link"].querySelector("a");
    if (this.menuItem) {
      const $link = this.menuItem?.href.split("#");
      this.isActive = $link.includes(window.location.href);
      this.menuItem.addEventListener("click", (e) => {
        e.preventDefault();
        this.onToggle();
      });
    }

    // this.menuItem?.addEventListener("focus", this.handleOpen);
    document.addEventListener("keydown", this.handleKeydown);
    window.addEventListener("click", () => {
      if (this.mouseOut)
        this.handleClose();
    });

    window.addEventListener("load", () => {
      this.getNotiHeight();
      window.addEventListener("resize", () => {
        this.getNotiHeight();
      });
    })
  },
  beforeUnmount() {
    EventBus.$off("closeMegamenu", this.handleClose);
    // EventBus.$off("focus-outside", this.handleFocusOutside);

    this.handleClose();

    this.menuItem?.removeEventListener("focus", this.handleOpen);
    document.removeEventListener("keydown", this.handleKeydown);
    this.menuItem = null;
  },
  methods: {
    getNotiHeight(){
      const $noti = document.querySelector(".notification-top");
      if($noti)
        this.$el.closest(".second-navbar-bottom").style.cssText = `--noti: ${$noti.offsetHeight}px`
    },
    onToggle() {
      this.onOpen(this.index);
      if (this.showMegamenu) this.handleClose();
      else this.handleOpen();
    },
    onOverflow(n) {
      document.querySelector("html").style.overflow = n;
    },
    handleOpen() {
      if (!this.showMegamenu) {
        EventBus.$emit("closeMegamenu");
        this.onOverflow("clip");
        this.showMegamenu = true;
      }
    },
    handleClose() {
      if (this.showMegamenu) {
        this.onOverflow("");
        this.showMegamenu = false;
      }
    },
    handleKeydown(event) {
      if (
        event.keyCode === 27 ||
        event.code === "Escape" ||
        event.code === "Esc"
      ) {
        if (this.showMegamenu) {
          this.handleClose();
        }
      }
    },
    handleMouseEvent(value) {
      this.mouseOut = value;
    },
    handleFocusOutside({ target }) {
      if (!this.showMegamenu || this.$refs["icon"]?.contains(target)) return;

      const menuItem = this.menuItem;
      const megamenu = this.$el.querySelector(".main-menu-dropdown-megamenu");

      if (menuItem?.contains(target) || megamenu?.contains(target)) return;
      this.handleClose();
    },
  },
};
</script>
